import BaseClient from '../base-client';
import Session, { formatSession } from './model';
import EventBus from '../../../event-bus';

export default class SessionClient extends BaseClient {
  constructor(options = {}) {
    super('rest_access', {
      format: formatSession,
      ...options,
    });
  }

  async login(credentials) {
    // eslint-disable-next-line object-curly-newline
    const { user, password, bopsid, os } = credentials;
    const headers = {};
    if (typeof bopsid === 'string') {
      headers['x-bopsid'] = bopsid;
    } else {
      const token = Buffer.from(`${user}:${password}`, 'utf8').toString('base64');
      headers.Authorization = `Basic ${token}`;
    }
    try {
      const response = await this.request('post')('<rest_access/>', {
        headers: {
          ...headers,
          'Content-Type': 'application/xml',
          'x-obj-attrs': 'contact',
          os,
        },
      });
      console.log('<rest_access/>', response);
      if (response.status === 212) {
        return response;
      }
      const dispatch = () => EventBus.dispatchEvent('session:fetch', response);
      EventBus.once('request:session', dispatch);
      dispatch();

      return this.format(response);
    } catch (ex) {
      console.log('<rest_access/>', { ex });
      throw this.handleError(ex);
    }
  }

  async fetch(id, session) {
    try {
      const response = await this.request('get', id)(null, {
        headers: {
          'x-obj-attrs': 'contact',
          'x-accesskey': session.access_key,
          'x-jwt-token': session.token,
        },
      });

      // this call wont return the jwt token so
      // we will set it manually to keep the storage consistent
      if (response && response.data && response.data.rest_access) {
        response.data.rest_access.token = session.token;
      }

      const dispatch = () => EventBus.dispatchEvent('session:fetch', response);
      EventBus.once('request:session', dispatch);
      dispatch();

      return this.format(response);
    } catch (ex) {
      throw this.handleError(ex);
    }
  }

  // logout = () => this.request('delete')()
  async logout() {
    try {
      const response = await this.request('delete', this.apiClient.accessKey)();
      return this.format(response);
    } catch (ex) {
      throw this.handleError(ex);
    }
  }

  async trustedThirdPartyAuth(tempCode) {
    /* const token = Buffer.from(`${user}:${password}`, 'utf8').toString('base64');
    headers.Authorization = `Basic ${token}`; */
    try {
      const response = await this.request('put', tempCode)(null, {
        path: '/trusted-third-party/authorize',
        headers: { 'Content-Type': 'application/json' },
      });

      const dispatch = () => EventBus.dispatchEvent('session:fetch', response);
      EventBus.once('request:session', dispatch);
      dispatch();

      return this.format(response);
    } catch (ex) {
      throw this.handleError(ex);
    }
  }
}

export {
  Session,
};
